import axios from 'axios';

// Always use relative URLs - nginx handles routing in production
// This works with dev proxy and production nginx reverse proxy
const API_BASE_URL = '';

// Create axios instance with base configuration
const httpClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include JWT token
httpClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration and logout user
httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't auto-logout on 401 from SSO endpoints (they have their own error handling)
    const isSsoEndpoint = error.config?.url?.includes('/auth/casdoor/');

    if (error.response?.status === 401 && !isSsoEndpoint) {
      // Clear access token and user data from browser
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');

      // Dispatch custom event to notify App component of auth state change
      window.dispatchEvent(new CustomEvent('authStateChanged'));

      // Redirect to login page
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default httpClient; 